export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/animation_for_kids.4d6d30b.svg";